import { action } from 'easy-peasy';
import { UserThemeExampleStore } from '../types';

export const userExampleStore: UserThemeExampleStore = {
  userTheme: 'light',
  setUserTheme: action((state, payload) => {
    state.userTheme = payload;
  }),
};
